import React, { useEffect, useState, useRef } from 'react';
import { actionLogout } from '../../module/LoginModule';
import { useDispatch } from 'react-redux';
import SessionStorageUtil from '../../util/SessionStorageUtil';
import AuthenticationUtil from '../../util/AuthenticationUtil';
import SessionExtendModal from '../../view/modal/SessionExtendModal';
import ModalRef from '../ModalRef';

const SessionMonitor = () => {
    const modalRef = useRef(null);

    const [signoutTime, setSignoutTime] = useState(3360000);
    const [warningTime, setWarningTime] = useState(3300000);

    let logoutTimeout;
    let warnTimeout;

    const dispatch = useDispatch();

    const warn = () => {
        if (AuthenticationUtil.isLogin()) {
            modalRef.current.open(<SessionExtendModal modalRef={modalRef} />, 'small');
        }
    };

    const logout = () => {
        if (AuthenticationUtil.isLogin()) {
            dispatch(
                actionLogout({
                    data: { forceLogout: true },
                    msg: '장기간 사용하지 않아 자동으로 로그아웃 되었습니다.',
                }),
            );
        }
    };

    const setTimeouts = () => {
        warnTimeout = setTimeout(warn, warningTime);
        logoutTimeout = setTimeout(logout, signoutTime);
    };

    const clearTimeouts = () => {
        if (warnTimeout) clearTimeout(warnTimeout);
        if (logoutTimeout) clearTimeout(logoutTimeout);
    };

    useEffect(() => {
        let date = SessionStorageUtil.getSessionValidTime();

        console.log('세션 유효 시간 : ' + date);

        if (date && new Date() - new Date(date) >= 0) {
            if (AuthenticationUtil.isLogin()) {
                SessionStorageUtil.setSessionValidTime(null);
                dispatch(actionLogout({ data: { forceLogout: true } }));
            }
        }

        const events = ['load', 'mousemove', 'mousedown', 'click', 'scroll', 'keypress'];

        const resetTimeout = () => {
            clearTimeouts();
            setTimeouts();
        };

        for (let i in events) {
            window.addEventListener(events[i], resetTimeout);
        }

        setTimeouts();
        return () => {
            for (let i in events) {
                window.removeEventListener(events[i], resetTimeout);
                clearTimeouts();
            }
        };
    }, []);

    return (
        <div>
            <ModalRef ref={modalRef} />
        </div>
    );
};
export default SessionMonitor;
